import { createContext, useContext, useState, useEffect } from 'react';

// Admin Translation strings
const adminTranslations = {
  de: {
    // Sidebar Navigation
    sidebar_dashboard: 'Dashboard',
    sidebar_cars: 'Fahrzeuge',
    sidebar_inquiries: 'Anfragen',
    sidebar_customers: 'Kunden',
    sidebar_test_drives: 'Probefahrten',
    sidebar_contracts: 'Verträge',
    sidebar_newsletter: 'Newsletter',
    sidebar_blog: 'Blog',
    sidebar_settings: 'Einstellungen',
    sidebar_logout: 'Abmelden',
    sidebar_analytics: 'Statistiken',
    sidebar_vehicles: 'Fahrzeuge',
    sidebar_test_drive: 'Probefahrten',
    sidebar_support: 'Support',
    sidebar_view_website: 'Website ansehen',
    sidebar_logged_in_as: 'Angemeldet als',
    
    // Menu label keys (used by menuItems)
    dashboard: 'Dashboard',
    analytics: 'Statistiken',
    vehicles: 'Fahrzeuge',
    test_drive: 'Probefahrten',
    customers: 'Kunden',
    contracts: 'Verträge',
    inquiries: 'Anfragen',
    car_requests: 'Fahrzeugsuche',
    blog: 'Blog',
    newsletter: 'Newsletter',
    settings: 'Einstellungen',
    support: 'Support',
    
    // Dashboard
    dashboard_title: 'Dashboard',
    dashboard_welcome: 'Willkommen zurück',
    dashboard_stats_cars: 'Fahrzeuge',
    dashboard_stats_inquiries: 'Anfragen',
    dashboard_stats_customers: 'Kunden',
    dashboard_stats_contracts: 'Verträge',
    dashboard_quick_access: 'Schnellzugriff',
    dashboard_recent_inquiries: 'Neueste Anfragen',
    dashboard_recent_cars: 'Neueste Fahrzeuge',
    dashboard_view_all: 'Alle anzeigen',
    dashboard_no_inquiries: 'Keine neuen Anfragen',
    dashboard_support: 'Support',
    dashboard_stats_analytics: 'Statistiken',
    dashboard_stats_desc: 'Übersicht',
    dashboard_tip: 'Tipp: Klicken Sie auf das ? oben rechts für eine Übersicht aller Funktionen',
    dashboard_admin_area: 'Admin-Bereich',
    dashboard_choose_option: 'Wählen Sie eine Option',
    dashboard_back_to_website: 'Zurück',
    
    // Settings Tabs
    settings_title: 'Einstellungen',
    settings_tab_general: 'Allgemein',
    settings_tab_modules: 'Module',
    settings_tab_design: 'Design',
    settings_tab_seo: 'SEO',
    settings_tab_legal: 'Rechtliches',
    settings_tab_api: 'API Keys',
    settings_tab_accounts: 'Konten',
    
    // General Settings
    settings_branding: 'Branding',
    settings_site_name: 'Website-Name',
    settings_site_name_hint: 'Wird im Header, Footer und E-Mails angezeigt',
    settings_logo_management: 'Logo-Verwaltung',
    settings_logo_light: 'Logo (Heller Hintergrund)',
    settings_logo_dark: 'Logo (Dunkler Hintergrund)',
    settings_logo_hint: 'Empfohlen: PNG mit transparentem Hintergrund',
    settings_upload: 'Hochladen',
    settings_or_url: 'Oder URL eingeben',
    
    // Hero Settings
    settings_hero: 'Hero-Bereich',
    settings_hero_hint: 'Das Hauptbild oder Video auf der Startseite',
    settings_hero_image: 'Hero-Bild',
    settings_hero_video: 'Oder: YouTube-Video URL',
    settings_hero_video_hint: 'Das Video wird stumm und in Schleife abgespielt',
    settings_hero_title: 'Überschrift',
    settings_hero_subtitle: 'Untertitel',
    
    // Navigation Settings
    settings_navigation: 'Navigation / Menü-Bezeichnungen',
    settings_nav_home: 'Home',
    settings_nav_vehicles: 'Fahrzeuge',
    settings_nav_about: 'Über uns',
    settings_nav_contact: 'Kontakt',
    settings_nav_favorites: 'Merkliste',
    
    // Footer Settings
    settings_footer: 'Footer',
    settings_footer_copyright: 'Copyright-Text',
    settings_footer_copyright_hint: 'Beispiel: "© 2025 Firmenname" oder "Firmenname GmbH"',
    settings_footer_hours: 'Öffnungszeiten',
    settings_footer_weekday: 'Wochentage',
    settings_footer_saturday: 'Samstag',
    settings_footer_sunday: 'Sonntag',
    settings_footer_description: 'Footer-Beschreibung',
    
    // Design Settings
    settings_design_hero: 'Hero-Design & Buttons',
    settings_design_hero_hint: 'Passen Sie die Farben und Buttons im Hero-Bereich an',
    settings_design_title_color: 'Überschrift-Farbe',
    settings_design_subtitle_color: 'Untertitel-Farbe',
    settings_design_primary_btn: 'Primärer Button',
    settings_design_secondary_btn: 'Sekundärer Button (Outline)',
    settings_design_btn_text: 'Button-Text',
    settings_design_btn_link: 'Link/Ziel',
    settings_design_btn_bg: 'Hintergrund',
    settings_design_btn_color: 'Textfarbe',
    settings_design_btn_border: 'Rahmenfarbe',
    settings_design_preview: 'Vorschau',
    
    // Font Settings
    settings_font: 'Schriftart',
    settings_font_hint: 'Wählen Sie die Schriftart für Ihre Website',
    settings_font_classic: 'Klassisch Elegant',
    settings_font_modern: 'Modern Clean',
    settings_font_sport: 'Sportlich',
    
    // Color Settings
    settings_colors: 'Farbeinstellungen',
    settings_colors_hint: 'Diese Farben werden für Buttons, Links und Akzente verwendet',
    settings_color_primary: 'Primärfarbe',
    settings_color_secondary: 'Sekundärfarbe',
    
    // Dark Mode Settings
    settings_dark_mode: 'Dunkelmodus',
    settings_dark_mode_allow: 'Dunkelmodus erlauben',
    settings_dark_mode_default: 'Standard-Modus',
    settings_dark_mode_light: 'Hell',
    settings_dark_mode_dark: 'Dunkel',
    
    // SEO Settings
    settings_seo: 'SEO Einstellungen',
    settings_seo_title: 'SEO Titel',
    settings_seo_description: 'Meta-Beschreibung',
    settings_seo_keywords: 'Keywords',
    settings_seo_hint: 'Kommagetrennte Begriffe für Suchmaschinen',
    
    // Legal Settings
    settings_legal: 'Rechtliche Seiten',
    settings_legal_privacy: 'Datenschutz',
    settings_legal_terms: 'AGB',
    settings_legal_imprint: 'Impressum',
    
    // API Keys
    settings_api_keys: 'API-Schlüssel',
    settings_api_resend: 'Resend API Key (E-Mail)',
    settings_api_turnstile: 'Cloudflare Turnstile',
    settings_api_site_key: 'Site Key',
    settings_api_secret_key: 'Secret Key',
    settings_api_save: 'Speichern',
    
    // Account Settings
    settings_account: 'Konto-Einstellungen',
    settings_account_username: 'Benutzername',
    settings_account_email: 'E-Mail-Adresse',
    settings_account_password: 'Passwort ändern',
    settings_account_current_pw: 'Aktuelles Passwort',
    settings_account_new_pw: 'Neues Passwort',
    settings_account_confirm_pw: 'Passwort bestätigen',
    
    // Module Settings
    module_featured: 'Empfohlene Fahrzeuge',
    module_brands: 'Marken & Partner',
    module_about: 'Über uns-Bereich',
    module_video: 'Video-Bereich',
    module_services: 'Werkstatt & Services',
    module_team: 'Team-Bereich',
    module_team_desc: 'Wenn aktiv: Im Menü + optional auf Startseite',
    module_blog: 'Blog / News',
    module_blog_desc: 'Wenn aktiv: Im Menü + optional auf Startseite',
    module_newsletter: 'Newsletter',
    module_contact: 'Kontakt-Bereich',
    module_faq: 'FAQ-Bereich',
    module_favorites: 'Merkliste / Favoriten',
    module_favorites_desc: 'Benutzer können Fahrzeuge speichern',
    module_compare: 'Fahrzeugvergleich',
    module_compare_desc: 'Mehrere Fahrzeuge vergleichen',
    module_financing: 'Finanzierungsrechner',
    module_financing_desc: 'Monatliche Raten berechnen',
    module_chat: 'Chat / Anfragen-System',
    module_chat_desc: 'Chat-Verlauf im Admin',
    module_price_alerts: 'Preisalarme',
    module_price_alerts_desc: 'Benachrichtigung bei Preisänderungen',
    module_test_drive: 'Probefahrt buchen',
    module_test_drive_desc: 'Probefahrt-Buchung im Menü & auf Fahrzeugseiten',
    modules_homepage: 'Startseiten-Module',
    modules_homepage_hint: 'Module aktivieren/deaktivieren und Reihenfolge ändern',
    modules_features: 'Feature-Module',
    modules_features_hint: 'Zusätzliche Funktionen für Ihre Website',
    modules_settings: 'Einstellungen',
    modules_drag_hint: 'Ziehen Sie Module, um die Reihenfolge zu ändern',
    modules_show_homepage: 'Auf Startseite',
    
    // Cars
    cars_title: 'Fahrzeuge',
    cars_add_new: 'Neues Fahrzeug',
    cars_search: 'Suchen...',
    cars_filter_all: 'Alle',
    cars_filter_available: 'Verfügbar',
    cars_filter_sold: 'Verkauft',
    cars_filter_reserved: 'Reserviert',
    cars_no_results: 'Keine Fahrzeuge gefunden',
    cars_edit: 'Bearbeiten',
    cars_delete: 'Löschen',
    cars_view: 'Ansehen',
    cars_tab_list: 'Fahrzeuge',
    cars_tab_categories: 'Kategorien',
    cars_manage_desc: 'Verwalten Sie Ihren Fahrzeugbestand',
    
    // Car Form
    car_form_title_new: 'Neues Auto',
    car_form_title_edit: 'Auto bearbeiten',
    car_form_brand: 'Marke',
    car_form_model: 'Modell',
    car_form_price: 'Preis',
    car_form_year: 'Baujahr',
    car_form_mileage: 'Kilometerstand',
    car_form_fuel: 'Kraftstoff',
    car_form_transmission: 'Getriebe',
    car_form_power: 'Leistung (PS)',
    car_form_color: 'Farbe',
    car_form_interior: 'Innenausstattung',
    car_form_doors: 'Türen',
    car_form_seats: 'Sitze',
    car_form_description: 'Beschreibung',
    car_form_features: 'Ausstattung',
    car_form_images: 'Bilder',
    car_form_status: 'Status',
    car_form_featured: 'Auf Startseite zeigen',
    car_form_save: 'Speichern',
    car_form_cancel: 'Abbrechen',
    
    // Inquiries
    inquiries_title: 'Anfragen',
    inquiries_unread: 'Ungelesen',
    inquiries_all: 'Alle',
    inquiries_archived: 'Archiv',
    inquiries_reply: 'Antworten',
    inquiries_archive: 'Archivieren',
    inquiries_delete: 'Löschen',
    inquiries_no_results: 'Keine Anfragen',
    inquiries_tab_messages: 'Nachrichten',
    inquiries_tab_settings: 'Auto-Antwort',
    inquiries_auto_reply: 'Auto-Antwort aktivieren',
    inquiries_auto_reply_msg: 'Auto-Antwort Nachricht',
    inquiries_offline_msg: 'Nachricht wenn Admin offline',
    
    // Customers
    customers_title: 'Kunden',
    customers_add_new: 'Neuer Kunde',
    customers_search: 'Suchen...',
    customers_no_results: 'Keine Kunden gefunden',
    customers_name: 'Name',
    customers_email: 'E-Mail',
    customers_phone: 'Telefon',
    customers_address: 'Adresse',
    customers_notes: 'Notizen',
    
    // Test Drives
    test_drives_title: 'Probefahrten',
    test_drives_calendar: 'Kalender',
    test_drives_list: 'Liste',
    test_drives_archive: 'Archiv',
    test_drives_no_bookings: 'Keine Buchungen',
    test_drives_confirm: 'Bestätigen',
    test_drives_cancel: 'Absagen',
    
    // Contracts
    contracts_title: 'Verträge',
    contracts_add_new: 'Neuer Vertrag',
    contracts_stats_signed: 'Unterschrieben',
    contracts_stats_sent: 'Verschickt',
    contracts_stats_open: 'Offen',
    contracts_archive: 'Archiv',
    contracts_send: 'Senden',
    contracts_download: 'PDF herunterladen',
    contracts_tab_list: 'Verträge',
    contracts_tab_settings: 'Einstellungen',
    contracts_signature: 'Händler-Unterschrift',
    contracts_signature_hint: 'Laden Sie Ihre Unterschrift als PNG-Datei mit transparentem Hintergrund hoch',
    contracts_how_it_works: 'So funktionieren Verträge:',
    contracts_active: 'aktive Verträge',
    contracts_show_active: 'Aktive anzeigen',
    contracts_new: 'Neuer Vertrag',
    contracts_new_purchase: 'Neuer Kaufvertrag',
    contracts_edit: 'Vertrag bearbeiten',
    contracts_customer: 'Kunde',
    contracts_vehicle: 'Fahrzeug',
    contracts_select_customer: 'Kunde wählen...',
    contracts_select_vehicle: 'Fahrzeug wählen...',
    contracts_settings: 'Einstellungen',
    contracts_open: 'Offen',
    contracts_status_draft: 'Entwurf',
    contracts_status_pending: 'Ausstehend',
    contracts_status_sent: 'Versendet',
    contracts_status_signed: 'Unterschrieben',
    contracts_status_cancelled: 'Storniert',
    contracts_price: 'Kaufpreis',
    contracts_payment_method: 'Zahlungsart',
    contracts_deposit: 'Anzahlung',
    contracts_warranty: 'Garantie',
    contracts_delivery_date: 'Lieferdatum',
    contracts_additional_terms_de: 'Zusätzliche Vereinbarungen (Deutsch)',
    contracts_additional_terms_en: 'Zusätzliche Vereinbarungen (Englisch)',
    contracts_save_draft: 'Als Entwurf speichern',
    contracts_create_send: 'Erstellen & Senden',
    contracts_update: 'Aktualisieren',
    contracts_info_title: 'Information',
    contracts_info_workflow: 'Verträge Workflow',
    contracts_info_step1: '1. Erstellen Sie einen Vertrag',
    contracts_info_step2: '2. Vertrag per E-Mail senden',
    contracts_info_step3: '3. Kunde unterschreibt digital',
    contracts_dealer_signature: 'Händler-Unterschrift',
    contracts_search: 'Suche nach Käufer oder Fahrzeug...',
    contracts_filter_status: 'Status filtern',
    contracts_no_results: 'Keine Verträge gefunden',
    contracts_delete_confirm: 'Vertrag wirklich löschen?',
    contracts_archive_confirm: 'Vertrag ins Archiv verschieben?',
    contracts_months: 'Monate',
    
    // Inquiries additional
    inquiries_autoreply_title: 'Auto-Antwort Einstellungen',
    inquiries_autoreply_desc: 'Konfigurieren Sie automatische Antworten für neue Anfragen.',
    inquiries_autoreply_activate: 'Auto-Antwort aktivieren',
    inquiries_autoreply_text: 'Antwort-Nachricht',
    inquiries_autoreply_placeholder: 'Geben Sie hier Ihre automatische Antwort ein...',
    
    // Error messages
    msg_error: 'Fehler beim Laden der Daten',
    
    // Newsletter
    newsletter_title: 'Newsletter',
    newsletter_subscribers: 'Abonnenten',
    newsletter_campaigns: 'Kampagnen',
    newsletter_new_campaign: 'Neue Kampagne',
    newsletter_subject: 'Betreff',
    newsletter_content: 'Inhalt',
    newsletter_send: 'Senden',
    newsletter_stats_sent: 'Gesendet',
    newsletter_stats_opened: 'Geöffnet',
    newsletter_stats_rate: 'Öffnungsrate',
    
    // Blog
    blog_title: 'Blog',
    blog_add_new: 'Neuer Beitrag',
    blog_post_title: 'Titel',
    blog_post_content: 'Inhalt',
    blog_post_image: 'Beitragsbild',
    blog_post_publish: 'Veröffentlichen',
    blog_post_draft: 'Als Entwurf speichern',
    
    // Common Actions
    action_save: 'Speichern',
    action_cancel: 'Abbrechen',
    action_delete: 'Löschen',
    action_edit: 'Bearbeiten',
    action_add: 'Hinzufügen',
    action_upload: 'Hochladen',
    action_search: 'Suchen',
    action_filter: 'Filtern',
    action_export: 'Exportieren',
    action_import: 'Importieren',
    action_refresh: 'Aktualisieren',
    action_back: 'Zurück',
    action_next: 'Weiter',
    action_confirm: 'Bestätigen',
    action_close: 'Schließen',
    
    // Status
    status_active: 'Aktiv',
    status_inactive: 'Inaktiv',
    status_pending: 'Ausstehend',
    status_completed: 'Abgeschlossen',
    status_cancelled: 'Storniert',
    status_available: 'Verfügbar',
    status_sold: 'Verkauft',
    status_reserved: 'Reserviert',
    
    // Messages
    msg_save_success: 'Erfolgreich gespeichert',
    msg_save_error: 'Fehler beim Speichern',
    msg_delete_success: 'Erfolgreich gelöscht',
    msg_delete_error: 'Fehler beim Löschen',
    msg_delete_confirm: 'Sind Sie sicher?',
    msg_loading: 'Wird geladen...',
    msg_no_data: 'Keine Daten vorhanden',
    
    // Language
    lang_german: 'Deutsch',
    lang_english: 'English',
    lang_switch: 'Sprache wechseln'
  },
  
  en: {
    // Sidebar Navigation
    sidebar_dashboard: 'Dashboard',
    sidebar_cars: 'Vehicles',
    sidebar_inquiries: 'Inquiries',
    sidebar_customers: 'Customers',
    sidebar_test_drives: 'Test Drives',
    sidebar_contracts: 'Contracts',
    sidebar_newsletter: 'Newsletter',
    sidebar_blog: 'Blog',
    sidebar_settings: 'Settings',
    sidebar_logout: 'Logout',
    sidebar_analytics: 'Analytics',
    sidebar_vehicles: 'Vehicles',
    sidebar_test_drive: 'Test Drives',
    sidebar_support: 'Support',
    sidebar_view_website: 'View Website',
    sidebar_logged_in_as: 'Logged in as',
    
    // Menu label keys (used by menuItems)
    dashboard: 'Dashboard',
    analytics: 'Analytics',
    vehicles: 'Vehicles',
    test_drive: 'Test Drives',
    customers: 'Customers',
    contracts: 'Contracts',
    inquiries: 'Inquiries',
    car_requests: 'Car Requests',
    blog: 'Blog',
    newsletter: 'Newsletter',
    settings: 'Settings',
    support: 'Support',
    
    // Dashboard
    dashboard_title: 'Dashboard',
    dashboard_welcome: 'Welcome back',
    dashboard_stats_cars: 'Vehicles',
    dashboard_stats_inquiries: 'Inquiries',
    dashboard_stats_customers: 'Customers',
    dashboard_stats_contracts: 'Contracts',
    dashboard_quick_access: 'Quick Access',
    dashboard_recent_inquiries: 'Recent Inquiries',
    dashboard_recent_cars: 'Recent Vehicles',
    dashboard_view_all: 'View All',
    dashboard_no_inquiries: 'No new inquiries',
    dashboard_support: 'Support',
    dashboard_stats_analytics: 'Analytics',
    dashboard_stats_desc: 'Overview',
    dashboard_tip: 'Tip: Click the ? in the top right for an overview of all features',
    dashboard_admin_area: 'Admin Area',
    dashboard_choose_option: 'Choose an option',
    dashboard_back_to_website: 'Back',
    
    // Settings Tabs
    settings_title: 'Settings',
    settings_tab_general: 'General',
    settings_tab_modules: 'Modules',
    settings_tab_design: 'Design',
    settings_tab_seo: 'SEO',
    settings_tab_legal: 'Legal',
    settings_tab_api: 'API Keys',
    settings_tab_accounts: 'Accounts',
    
    // General Settings
    settings_branding: 'Branding',
    settings_site_name: 'Website Name',
    settings_site_name_hint: 'Displayed in header, footer and emails',
    settings_logo_management: 'Logo Management',
    settings_logo_light: 'Logo (Light Background)',
    settings_logo_dark: 'Logo (Dark Background)',
    settings_logo_hint: 'Recommended: PNG with transparent background',
    settings_upload: 'Upload',
    settings_or_url: 'Or enter URL',
    
    // Hero Settings
    settings_hero: 'Hero Section',
    settings_hero_hint: 'The main image or video on the homepage',
    settings_hero_image: 'Hero Image',
    settings_hero_video: 'Or: YouTube Video URL',
    settings_hero_video_hint: 'The video will play muted and looped',
    settings_hero_title: 'Headline',
    settings_hero_subtitle: 'Subtitle',
    
    // Navigation Settings
    settings_navigation: 'Navigation / Menu Labels',
    settings_nav_home: 'Home',
    settings_nav_vehicles: 'Vehicles',
    settings_nav_about: 'About Us',
    settings_nav_contact: 'Contact',
    settings_nav_favorites: 'Favorites',
    
    // Footer Settings
    settings_footer: 'Footer',
    settings_footer_copyright: 'Copyright Text',
    settings_footer_copyright_hint: 'Example: "© 2025 Company Name" or "Company Name Ltd"',
    settings_footer_hours: 'Opening Hours',
    settings_footer_weekday: 'Weekdays',
    settings_footer_saturday: 'Saturday',
    settings_footer_sunday: 'Sunday',
    settings_footer_description: 'Footer Description',
    
    // Design Settings
    settings_design_hero: 'Hero Design & Buttons',
    settings_design_hero_hint: 'Customize the colors and buttons in the hero section',
    settings_design_title_color: 'Title Color',
    settings_design_subtitle_color: 'Subtitle Color',
    settings_design_primary_btn: 'Primary Button',
    settings_design_secondary_btn: 'Secondary Button (Outline)',
    settings_design_btn_text: 'Button Text',
    settings_design_btn_link: 'Link/Target',
    settings_design_btn_bg: 'Background',
    settings_design_btn_color: 'Text Color',
    settings_design_btn_border: 'Border Color',
    settings_design_preview: 'Preview',
    
    // Font Settings
    settings_font: 'Font',
    settings_font_hint: 'Choose the font for your website',
    settings_font_classic: 'Classic Elegant',
    settings_font_modern: 'Modern Clean',
    settings_font_sport: 'Sporty',
    
    // Color Settings
    settings_colors: 'Color Settings',
    settings_colors_hint: 'These colors are used for buttons, links and accents',
    settings_color_primary: 'Primary Color',
    settings_color_secondary: 'Secondary Color',
    
    // Dark Mode Settings
    settings_dark_mode: 'Dark Mode',
    settings_dark_mode_allow: 'Allow Dark Mode',
    settings_dark_mode_default: 'Default Mode',
    settings_dark_mode_light: 'Light',
    settings_dark_mode_dark: 'Dark',
    
    // SEO Settings
    settings_seo: 'SEO Settings',
    settings_seo_title: 'SEO Title',
    settings_seo_description: 'Meta Description',
    settings_seo_keywords: 'Keywords',
    settings_seo_hint: 'Comma-separated terms for search engines',
    
    // Legal Settings
    settings_legal: 'Legal Pages',
    settings_legal_privacy: 'Privacy Policy',
    settings_legal_terms: 'Terms & Conditions',
    settings_legal_imprint: 'Imprint',
    
    // API Keys
    settings_api_keys: 'API Keys',
    settings_api_resend: 'Resend API Key (Email)',
    settings_api_turnstile: 'Cloudflare Turnstile',
    settings_api_site_key: 'Site Key',
    settings_api_secret_key: 'Secret Key',
    settings_api_save: 'Save',
    
    // Account Settings
    settings_account: 'Account Settings',
    settings_account_username: 'Username',
    settings_account_email: 'Email Address',
    settings_account_password: 'Change Password',
    settings_account_current_pw: 'Current Password',
    settings_account_new_pw: 'New Password',
    settings_account_confirm_pw: 'Confirm Password',
    
    // Module Settings
    module_featured: 'Featured Vehicles',
    module_brands: 'Brands & Partners',
    module_about: 'About Section',
    module_video: 'Video Section',
    module_services: 'Workshop & Services',
    module_team: 'Team Section',
    module_team_desc: 'When active: In menu + optionally on homepage',
    module_blog: 'Blog / News',
    module_blog_desc: 'When active: In menu + optionally on homepage',
    module_newsletter: 'Newsletter',
    module_contact: 'Contact Section',
    module_faq: 'FAQ Section',
    module_favorites: 'Wishlist / Favorites',
    module_favorites_desc: 'Users can save vehicles',
    module_compare: 'Vehicle Comparison',
    module_compare_desc: 'Compare multiple vehicles',
    module_financing: 'Finance Calculator',
    module_financing_desc: 'Calculate monthly payments',
    module_chat: 'Chat / Inquiry System',
    module_chat_desc: 'Chat history in admin',
    module_price_alerts: 'Price Alerts',
    module_price_alerts_desc: 'Notification on price changes',
    module_test_drive: 'Book Test Drive',
    module_test_drive_desc: 'Test drive booking in menu & on vehicle pages',
    modules_homepage: 'Homepage Modules',
    modules_homepage_hint: 'Enable/disable modules and change order',
    modules_features: 'Feature Modules',
    modules_features_hint: 'Additional features for your website',
    modules_settings: 'Settings',
    modules_drag_hint: 'Drag modules to change order',
    modules_show_homepage: 'Show on Homepage',
    
    // Cars
    cars_title: 'Vehicles',
    cars_add_new: 'New Vehicle',
    cars_search: 'Search...',
    cars_filter_all: 'All',
    cars_filter_available: 'Available',
    cars_filter_sold: 'Sold',
    cars_filter_reserved: 'Reserved',
    cars_no_results: 'No vehicles found',
    cars_edit: 'Edit',
    cars_delete: 'Delete',
    cars_view: 'View',
    cars_tab_list: 'Vehicles',
    cars_tab_categories: 'Categories',
    cars_manage_desc: 'Manage your vehicle inventory',
    
    // Car Form
    car_form_title_new: 'New Car',
    car_form_title_edit: 'Edit Car',
    car_form_brand: 'Brand',
    car_form_model: 'Model',
    car_form_price: 'Price',
    car_form_year: 'Year',
    car_form_mileage: 'Mileage',
    car_form_fuel: 'Fuel Type',
    car_form_transmission: 'Transmission',
    car_form_power: 'Power (HP)',
    car_form_color: 'Color',
    car_form_interior: 'Interior',
    car_form_doors: 'Doors',
    car_form_seats: 'Seats',
    car_form_description: 'Description',
    car_form_features: 'Features',
    car_form_images: 'Images',
    car_form_status: 'Status',
    car_form_featured: 'Show on Homepage',
    car_form_save: 'Save',
    car_form_cancel: 'Cancel',
    
    // Inquiries
    inquiries_title: 'Inquiries',
    inquiries_unread: 'Unread',
    inquiries_all: 'All',
    inquiries_archived: 'Archive',
    inquiries_reply: 'Reply',
    inquiries_archive: 'Archive',
    inquiries_delete: 'Delete',
    inquiries_no_results: 'No inquiries',
    inquiries_tab_messages: 'Messages',
    inquiries_tab_settings: 'Auto-Reply',
    inquiries_auto_reply: 'Enable Auto-Reply',
    inquiries_auto_reply_msg: 'Auto-Reply Message',
    inquiries_offline_msg: 'Message when Admin offline',
    
    // Customers
    customers_title: 'Customers',
    customers_add_new: 'New Customer',
    customers_search: 'Search...',
    customers_no_results: 'No customers found',
    customers_name: 'Name',
    customers_email: 'Email',
    customers_phone: 'Phone',
    customers_address: 'Address',
    customers_notes: 'Notes',
    
    // Test Drives
    test_drives_title: 'Test Drives',
    test_drives_calendar: 'Calendar',
    test_drives_list: 'List',
    test_drives_archive: 'Archive',
    test_drives_no_bookings: 'No bookings',
    test_drives_confirm: 'Confirm',
    test_drives_cancel: 'Cancel',
    
    // Contracts
    contracts_title: 'Contracts',
    contracts_add_new: 'New Contract',
    contracts_stats_signed: 'Signed',
    contracts_stats_sent: 'Sent',
    contracts_stats_open: 'Open',
    contracts_archive: 'Archive',
    contracts_send: 'Send',
    contracts_download: 'Download PDF',
    contracts_tab_list: 'Contracts',
    contracts_tab_settings: 'Settings',
    contracts_signature: 'Dealer Signature',
    contracts_signature_hint: 'Upload your signature as a PNG file with transparent background',
    contracts_how_it_works: 'How contracts work:',
    contracts_active: 'active contracts',
    contracts_show_active: 'Show active',
    contracts_new: 'New Contract',
    contracts_new_purchase: 'New Purchase Contract',
    contracts_edit: 'Edit Contract',
    contracts_customer: 'Customer',
    contracts_vehicle: 'Vehicle',
    contracts_select_customer: 'Select customer...',
    contracts_select_vehicle: 'Select vehicle...',
    contracts_settings: 'Settings',
    contracts_open: 'Open',
    contracts_status_draft: 'Draft',
    contracts_status_pending: 'Pending',
    contracts_status_sent: 'Sent',
    contracts_status_signed: 'Signed',
    contracts_status_cancelled: 'Cancelled',
    contracts_price: 'Purchase Price',
    contracts_payment_method: 'Payment Method',
    contracts_deposit: 'Deposit',
    contracts_warranty: 'Warranty',
    contracts_delivery_date: 'Delivery Date',
    contracts_additional_terms_de: 'Additional Terms (German)',
    contracts_additional_terms_en: 'Additional Terms (English)',
    contracts_save_draft: 'Save as Draft',
    contracts_create_send: 'Create & Send',
    contracts_update: 'Update',
    contracts_info_title: 'Information',
    contracts_info_workflow: 'Contract Workflow',
    contracts_info_step1: '1. Create a contract',
    contracts_info_step2: '2. Send contract via email',
    contracts_info_step3: '3. Customer signs digitally',
    contracts_dealer_signature: 'Dealer Signature',
    contracts_search: 'Search by buyer or vehicle...',
    contracts_filter_status: 'Filter by status',
    contracts_no_results: 'No contracts found',
    contracts_delete_confirm: 'Really delete contract?',
    contracts_archive_confirm: 'Move contract to archive?',
    contracts_months: 'months',
    
    // Inquiries additional
    inquiries_autoreply_title: 'Auto-Reply Settings',
    inquiries_autoreply_desc: 'Configure automatic replies for new inquiries.',
    inquiries_autoreply_activate: 'Enable Auto-Reply',
    inquiries_autoreply_text: 'Reply Message',
    inquiries_autoreply_placeholder: 'Enter your automatic reply here...',
    
    // Error messages
    msg_error: 'Error loading data',
    
    // Newsletter
    newsletter_title: 'Newsletter',
    newsletter_subscribers: 'Subscribers',
    newsletter_campaigns: 'Campaigns',
    newsletter_new_campaign: 'New Campaign',
    newsletter_subject: 'Subject',
    newsletter_content: 'Content',
    newsletter_send: 'Send',
    newsletter_stats_sent: 'Sent',
    newsletter_stats_opened: 'Opened',
    newsletter_stats_rate: 'Open Rate',
    
    // Blog
    blog_title: 'Blog',
    blog_add_new: 'New Post',
    blog_post_title: 'Title',
    blog_post_content: 'Content',
    blog_post_image: 'Featured Image',
    blog_post_publish: 'Publish',
    blog_post_draft: 'Save as Draft',
    
    // Common Actions
    action_save: 'Save',
    action_cancel: 'Cancel',
    action_delete: 'Delete',
    action_edit: 'Edit',
    action_add: 'Add',
    action_upload: 'Upload',
    action_search: 'Search',
    action_filter: 'Filter',
    action_export: 'Export',
    action_import: 'Import',
    action_refresh: 'Refresh',
    action_back: 'Back',
    action_next: 'Next',
    action_confirm: 'Confirm',
    action_close: 'Close',
    
    // Status
    status_active: 'Active',
    status_inactive: 'Inactive',
    status_pending: 'Pending',
    status_completed: 'Completed',
    status_cancelled: 'Cancelled',
    status_available: 'Available',
    status_sold: 'Sold',
    status_reserved: 'Reserved',
    
    // Messages
    msg_save_success: 'Saved successfully',
    msg_save_error: 'Error saving',
    msg_delete_success: 'Deleted successfully',
    msg_delete_error: 'Error deleting',
    msg_delete_confirm: 'Are you sure?',
    msg_loading: 'Loading...',
    msg_no_data: 'No data available',
    
    // Language
    lang_german: 'Deutsch',
    lang_english: 'English',
    lang_switch: 'Switch Language'
  }
};

const AdminLanguageContext = createContext();

export function AdminLanguageProvider({ children }) {
  const [adminLang, setAdminLang] = useState(() => {
    return localStorage.getItem('admin_language') || 'de';
  });

  useEffect(() => {
    localStorage.setItem('admin_language', adminLang);
  }, [adminLang]);

  const toggleAdminLang = () => {
    setAdminLang(prev => prev === 'de' ? 'en' : 'de');
  };

  const setLanguage = (lang) => {
    if (lang === 'de' || lang === 'en') {
      setAdminLang(lang);
    }
  };

  const t = (key) => {
    return adminTranslations[adminLang]?.[key] || adminTranslations['de']?.[key] || key;
  };

  return (
    <AdminLanguageContext.Provider value={{ 
      adminLang, 
      toggleAdminLang, 
      setLanguage,
      t,
      isEnglish: adminLang === 'en'
    }}>
      {children}
    </AdminLanguageContext.Provider>
  );
}

export function useAdminLanguage() {
  const context = useContext(AdminLanguageContext);
  if (!context) {
    throw new Error('useAdminLanguage must be used within AdminLanguageProvider');
  }
  return context;
}
